import { ZIP_CODE_REG } from '~/util/constants';
import { getZipInfo } from '~/util/lendingtree';

export const CheckZipOnline = async (userInputZip: string, DEFAULT_ZIP: string): Promise<string> => {
  const zipInfo = await getZipInfo(userInputZip);
  let zipCode = zipInfo?.zipCodes?.length ? zipInfo.zipCodes[0].zip5 : '';

  // Location service issue fallback
  if (!zipCode) {
    zipCode = ZIP_CODE_REG.test(userInputZip) ? userInputZip : DEFAULT_ZIP;
  }
  return zipCode;
};
